// Available tags for prompt selection
export const AVAILABLE_TAGS = [
    "medical",
    "support",
    "analysis",
    "creative",
    "technical",
    "general",
    "default",
] as const;

// Tag color mapping for chips
export const TAG_COLORS = {
    medical: "error",
    support: "info",
    analysis: "primary",
    creative: "secondary",
    technical: "success",
    general: "warning",
    default: "default",
} as const;

// Default dimensions for API compatibility
export const DEFAULT_DIMENSIONS = ["default"] as const;
